export const aasApiKeysQueryKeys = {
  all: ['aas_api_keys'],
  details: () => [...aasApiKeysQueryKeys.all, 'detail'],
  detail: (id) => [...aasApiKeysQueryKeys.details(), id],
  pagination: (page) => [...aasApiKeysQueryKeys.all, 'pagination', page],
  infinite: () => [...aasApiKeysQueryKeys.all, 'infinite'],
};
